import './index.css'

import React from 'react'
type Props = {
  label: React.ReactNode
  children?: React.ReactNode
}

const SwitchLabel = ({
  label,
  children,
}: Props): React.ReactNode | React.ReactElement<'div'> => (
  <div className="switch-toggle--label">
    {label}
    {children && <div className="switch-tool-tip--icon">{children}</div>}
  </div>
)

export default SwitchLabel
